import { render, staticRenderFns } from "./contract-lend.vue?vue&type=template&id=648ee476&scoped=true"
import script from "./contract-lend.vue?vue&type=script&lang=js"
export * from "./contract-lend.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=648ee476&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648ee476",
  null
  
)

export default component.exports